(function () {
  var _dismissSlideAlert = function dismissSlideAlert(element) {
    element.css('max-height', element.height() + 'px');
    window.setTimeout(function () {
      element.trigger('close.bs.alert');
      element.css('max-height', '0px');
      window.setTimeout(function () {
        element.trigger('closed.bs.alert');
        element.remove();
      }, 250);
    }, 15);
  };

  $.fn.extend({
    dismissSlideAlert: function dismissSlideAlert() {
      _dismissSlideAlert(this);
    }
  });
  $(document).ready(function () {
    $('[data-dismiss-slide="alert"]').on('click', function (event) {
      var container = $(event.currentTarget).closest('.alert-slide-container');

      _dismissSlideAlert(container);
    });
  });
})();

(function () {
  $.fn.extend({
    compatibleBrowser: function compatibleBrowser() {
      if (!Modernizr) {
        console.warn('Can\'t detect browser features without Modernizr');
        return true;
      }

      var requiredFeatures = [{
        feature: 'flexbox',
        supported: Modernizr.flexbox
      }, {
        feature: 'cssgradients',
        supported: Modernizr.cssgradients
      }, {
        feature: 'opacity',
        supported: Modernizr.opacity
      }, {
        feature: 'csspositionsticky',
        supported: Modernizr.csspositionsticky
      }, {
        feature: 'csstransforms',
        supported: Modernizr.csstransforms
      }, {
        feature: 'cssremunit',
        supported: Modernizr.cssremunit
      }, {
        feature: 'mediaqueries',
        supported: Modernizr.mediaqueries
      }, {
        feature: 'rgba',
        supported: Modernizr.rgba
      }, {
        feature: 'generatedcontent',
        supported: Modernizr.generatedcontent
      }];
      var unsupportedFeatures = requiredFeatures.filter(function (x) {
        if (!x.supported) {
          console.error("Required browser feature ".concat(x.feature, " is not supported."));
          return true;
        }

        return false;
      });
      return unsupportedFeatures.length === 0;
    }
  });
})();

(function () {
  var events = {
    hide: 'hide.chubby.drawer',
    hidden: 'hidden.chubby.drawer',
    show: 'show.chubby.drawer',
    shown: 'shown.chubby.drawer',
    transitionEnd: 'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd'
  };
  var dataKey = 'registered-events';

  var hide = function hide(getDrawer, getCurrentTrigger, getAllTriggers) {
    var _a = [getDrawer(), getCurrentTrigger()],
        drawer = _a[0],
        currentTrigger = _a[1];
    currentTrigger.trigger(events.hide, [drawer]);
    drawer.on(events.transitionEnd, function () {
      var _a;

      _a = [getDrawer(), getCurrentTrigger()], drawer = _a[0], currentTrigger = _a[1];
      currentTrigger.trigger(events.hidden, [drawer]);
      drawer.removeClass('d-flex').addClass('d-none');
      drawer.off(events.transitionEnd);
    });
    drawer.removeClass('show');
    getAllTriggers().removeClass('active');
  };

  var show = function show(getDrawer, getCurrentTrigger, getAllTriggers) {
    var _a = [getDrawer(), getCurrentTrigger()],
        drawer = _a[0],
        currentTrigger = _a[1];
    currentTrigger.trigger(events.show, [drawer]);
    drawer.removeClass('d-none').addClass('d-flex');
    getAllTriggers().addClass('active');
    setTimeout(function () {
      drawer = getDrawer();
      drawer.one(events.transitionEnd, function () {
        var _a;

        _a = [getDrawer(), getCurrentTrigger()], drawer = _a[0], currentTrigger = _a[1];
        currentTrigger.trigger(events.shown, [drawer]);
        drawer.find('.drawer-body').focus();
        drawer.off(events.transitionEnd);
      });
      drawer.addClass('show');
    }, 200);
  };

  $.fn.extend({
    drawer: function drawer(method) {
      var _this = this;

      if (method === void 0) {
        method = null;
      }

      this.each(function (index) {
        var getCurrentTrigger = function getCurrentTrigger() {
          return $(_this[index]);
        };

        var getDrawer = function getDrawer() {
          var currentTrigger = getCurrentTrigger();

          if (currentTrigger.hasClass('drawer') || currentTrigger.hasClass('drawer-mobile') || currentTrigger.hasClass('drawer-desktop')) {
            return currentTrigger;
          }

          return $(currentTrigger.data('target'));
        };

        var getAllTriggers = function getAllTriggers() {
          return $("[data-target='".concat(getCurrentTrigger().data('target'), "']"));
        };

        if (!getDrawer()) {
          throw new Error('No drawer target defined.');
        }

        if (method) {
          switch (method) {
            case 'show':
              show(getDrawer, getCurrentTrigger, getAllTriggers);
              break;

            case 'hide':
              hide(getDrawer, getCurrentTrigger, getAllTriggers);
              break;

            default:
              throw new Error("drawer method '".concat(method, "' not supported."));
          }
        } else {
          var drawer = getDrawer();
          getCurrentTrigger().on(getCurrentTrigger().data('trigger') || 'click', function () {
            show(getDrawer, getCurrentTrigger, getAllTriggers);
          });

          if (drawer.data(dataKey) !== true) {
            drawer.data(dataKey, true);
            drawer.keyup(function (event) {
              if (event.which === 27) {
                  hide(getDrawer, getCurrentTrigger, getAllTriggers);
                }
            });
            drawer.on('click', function (event) {
              if (event.target === event.currentTarget) {
                hide(getDrawer, getCurrentTrigger, getAllTriggers);
              }
            });
            drawer.find('[data-dismiss="drawer"]').on('click', function () {
              return hide(getDrawer, getCurrentTrigger, getAllTriggers);
            });
          }
        }
      });
      return this;
    }
  });
})();

(function () {
  $.fn.extend({
    markTriggerAsActive: function markTriggerAsActive() {
      var _this = this;

      this.each(function (index) {
        $(_this[index]).on('show.bs.popover', function (showEvent) {
          var target = $(showEvent.currentTarget);
          target.addClass('active');
          target.one('hide.bs.popover', function (hideEvent) {
            $(hideEvent.target).removeClass('active');
          });
        });
      });
      return this;
    }
  });
})();

(function () {
  var Direction;

  (function (Direction) {
    Direction["Left"] = "left";
    Direction["Right"] = "right";
  })(Direction || (Direction = {}));

  var buttonScrollAmount = 150;
  var buttonScrollTime = 100;

  var GetStateDirectionClassName = function GetStateDirectionClassName(direction) {
    return 'can-scroll-' + direction;
  };

  var GetScrollArrowDirectionClassName = function GetScrollArrowDirectionClassName(direction) {
    return 'scroll-arrow-' + direction;
  };

  var _scrollToNavElement = function scrollToNavElement(container, element, duration) {
    if (!container || !element || !element.length) {
      return;
    }

    var scrollTo = element[0].offsetLeft + element.width() / 2 - container.width() / 2;
    container.animate({
      scrollLeft: scrollTo
    }, duration);
  };

  var removeScrollArrow = function removeScrollArrow(container, direction) {
    container.removeClass(GetStateDirectionClassName(direction));
  };

  var addScrollArrow = function addScrollArrow(container, direction) {
    container.addClass(GetStateDirectionClassName(direction));
  };

  var ensureArrowElements = function ensureArrowElements(container) {
    ensureArrowElement(container, Direction.Left);
    ensureArrowElement(container, Direction.Right);
  };

  var ensureArrowElement = function ensureArrowElement(container, direction) {
    var element = findArrowElement(container, direction);

    if (!element.length) {
      var html = "<li class=\"".concat(GetScrollArrowDirectionClassName(direction), "\">\n    <div class=\"icon-container\">\n        <i class=\"fas fa-caret-").concat(direction, "\" aria-label=\"Scroll ").concat(direction, "\"></i>\n    </div>\n</div>");

      if (direction === Direction.Left) {
        container.prepend(html);
      } else {
        container.append(html);
      }

      element = findArrowElement(container, direction);
      element.on('click', function () {
        var scrollAmount = buttonScrollAmount;

        if (direction === Direction.Left) {
          scrollAmount = scrollAmount * -1;
        }

        container.animate({
          scrollLeft: container[0].scrollLeft + scrollAmount
        }, buttonScrollTime);
      });
    }
  };

  var findArrowElement = function findArrowElement(container, direction) {
    return container.find('.' + GetScrollArrowDirectionClassName(direction));
  };

  var handleScrollArrow = function handleScrollArrow(container, direction, canScroll) {
    if (canScroll) {
      addScrollArrow(container, direction);
    } else {
      removeScrollArrow(container, direction);
    }
  };

  var handleScrollArrows = function handleScrollArrows(container) {
    var elemWidth = Math.ceil(container.width());
    var scrollWidth = Math.ceil(container[0].scrollWidth);
    var scrollPos = Math.ceil(container[0].scrollLeft);
    var canScroll = elemWidth < scrollWidth;
    handleScrollArrow(container, Direction.Left, canScroll && scrollPos > 0);
    handleScrollArrow(container, Direction.Right, canScroll && scrollPos + elemWidth < scrollWidth);
  };

  $.fn.extend({
    scrollToNavElement: function scrollToNavElement(element, duration) {
      var _this = this;

      if (duration === void 0) {
        duration = 0;
      }

      this.each(function (index) {
        var target = $(_this[index]);

        _scrollToNavElement(target, element, duration);
      });
      return this;
    },
    addScrollArrows: function addScrollArrows() {
      var _this = this;

      this.each(function (index) {
        var target = $(_this[index]);
        handleScrollArrows(target);
        $(window).on('resize', function () {
          return handleScrollArrows(target);
        });
        target.on('scroll', function () {
          return handleScrollArrows(target);
        });
        ensureArrowElements(target);
      });
      return this;
    }
  });
})();

(function () {
  var handleEvent = function handleEvent(event) {
    var target = $(event.currentTarget);
    var allowedColours = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark'];
    var colour = target.attr('data-colour');

    if (colour && allowedColours.find(function (c) {
      return c === colour;
    })) {
      $('#' + target.attr('aria-describedby')).addClass('tooltip-' + colour);
    }
  };

  $.fn.extend({
    colouredTooltips: function colouredTooltips() {
      this.on('inserted.bs.tooltip', handleEvent);
    }
  });
})();

(function () {
  var cssClass = 'open';

  var collapseOpened = function collapseOpened(event) {
    var target = $(event.currentTarget);
    var highlight = $(target.data('highlight-target'));
    highlight.addClass(cssClass);
  };

  var collapseClosed = function collapseClosed(event) {
    var target = $(event.currentTarget);
    var highlight = $(target.data('highlight-target'));
    highlight.removeClass(cssClass);
  };

  $.fn.extend({
    collapseExtensions: function collapseExtensions() {
      var _this = this;

      this.each(function () {
        var elem = $(_this);
        var dataKey = 'collapse-extended';

        if (elem.data(dataKey) === true) {
          return;
        }

        elem.data(dataKey, true);
        var collapseTarget = $(elem.data('target'));
        collapseTarget.on('show.bs.collapse', collapseOpened);
        collapseTarget.on('hide.bs.collapse', collapseClosed);
      });
    }
  });
})();

(function () {
  function animate(e) {
    var button = this;

    if (button.querySelectorAll('.button-ripple').length === 0) {
      var span = document.createElement('span');
      span.classList.add('button-ripple');
      button.appendChild(span);
    }

    var ink = button.querySelectorAll('.button-ripple')[0];
    ink.classList.remove('animate');

    if (!ink.offsetHeight && !ink.offsetWidth) {
      var d = Math.max(button.offsetHeight, button.offsetWidth);
      ink.style.height = "".concat(d, "px");
      ink.style.width = "".concat(d, "px");
    }

    var rect = button.getBoundingClientRect();
    var offset = {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
    var x = e.pageX - offset.left - ink.offsetWidth / 2;
    var y = e.pageY - offset.top - ink.offsetHeight / 2;
    ink.style.top = "".concat(y, "px");
    ink.style.left = "".concat(x, "px");
    ink.classList.add('animate');
  }

  $.fn.extend({
    rippleButton: function rippleButton() {
      var _this = this;

      this.each(function (index) {
        var target = $(_this[index]);
        target.on('click', animate);
      });
    },
    globalRippleButtons: function globalRippleButtons() {
      $(document).on('click', '.btn', animate);
    }
  });
})();
//# sourceMappingURL=chubby.js.map
